// extracted by mini-css-extract-plugin
export var columns = "FiftyFiftyText-module--columns--8afac";
export var contained = "FiftyFiftyText-module--contained--09d0d";
export var content = "FiftyFiftyText-module--content--ab0d1";
export var fiftyfiftytext = "FiftyFiftyText-module--fiftyfiftytext--0e4bc";